<script>
  import { onMount } from "svelte";

  import { removeFromCart } from "../stores";
  import { isObjectEmpty } from "../utils.js";

  export let item;

  export let showRemoveBtn = false;

  export let itemStyle;

  $: originalPrice = item.price * item.count;
  $: newPrice = originalPrice - item.price * item.numOfFreeItems;

</script>

<div class="item">
  {#if showRemoveBtn}
    <div
      class="removeBtn"
      on:click={() => {
        removeFromCart(item);
      }}
    />
  {/if}
  {#if item.count > 1}
    <div class="count">{'x' + item.count}</div>
  {/if}
  <div class="name">
    {#if item.numOfFreeItems}
      <div class="freeTag">
        {item.numOfFreeItems}
        <div class="x" />
        <span>חינם!</span>
      </div>
    {/if}
    {item.name}
  </div>
  <hr />

  <div class="price" class:crossed={item.numOfFreeItems}>
    {originalPrice}
    <span> ₪ </span>
  </div>

  {#if item.numOfFreeItems}
    <div class="isFree" class:green={item.numOfFreeItems}>
      {newPrice}
      <span> ₪ </span>
    </div>
  {/if}
</div>

<div
  class="itemDetails"
  class:cartStyle={itemStyle == 'cart'}
  class:orderStyle={itemStyle == 'order'}
  class:closedOrderStyle={itemStyle == 'closed'}
  class:adminStyle={itemStyle == 'admin'}
>
  {#if !isObjectEmpty(item.options)}
    <div class="section details">
      {#each Object.keys(item.options) as option, i}
        <div class="option">
          {#if option != '_'}
            <span>{option + ': '}</span>
            {item.options[option]}.
            <br />
          {:else}
            {item.options[option]}
            {i < Object.keys(item.options).length - 1 ? ', ' : '.'}
          {/if}
        </div>
      {/each}
    </div>
  {/if}

  {#if !isObjectEmpty(item.checkboxes)}
    {#each Object.entries(item.checkboxes) as [sectionName, section]}
      <div class="section details">
        {#if !isObjectEmpty(section.items)}<span>{sectionName}:</span>{/if}
        <div class="boxes">
          {#each Object.values(section.items) as checkbox, i}
            <div class="checkbox">
              <div class="count">
                {#if checkbox.count > 1}{checkbox.count} x{/if}
              </div>
              <div class="checkboxLabel">{checkbox.label}</div>
            </div>
          {/each}
        </div>
      </div>
    {/each}
  {/if}
</div>

<style>
  .freeTag {
    position: absolute;
    display: flex;
    align-items: center;
    color: var(--green1);
    background: white;
    font-weight: 500;
    left: -49px;
    top: -20px;
    transform: rotate(-15deg);
    padding-right: 9px;
    border-radius: 5px;
    color: white;
    background: var(--green1);
    font-size: 14px;
  }

  span {
    width: max-content;
    white-space: pre-wrap;
  }

  .crossed {
    text-decoration: line-through;
  }
  .isFree {
    text-decoration: none;
    min-width: fit-content;
  }
  .green {
    color: var(--green1);
  }

  .details {
    overflow: visible;
  }

  .section.details {
    margin-top: 0px;
  }
  .item {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 15px;
    white-space: pre-line;
    width: 100%;
    margin: 0;
    margin-left: 10px;
    padding-left: 20px;
    font-size: 18px;
  }

  hr {
    border: none;
    border-bottom: 4px dotted gray;
    margin-left: 12px;
    margin-right: 12px;
    flex-grow: 1;
    min-width: 30px;
    height: 0px;
  }

  .removeBtn {
    background: var(--red1);
    padding: 5px;
    color: white;
    border-radius: 50px;
    min-width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15px;
    margin-right: 5px;
  }

  .removeBtn::before,
  .removeBtn::after {
    position: absolute;
    width: 12px;
    height: 2px;
    background: white;
    content: "";
    border-radius: 60px;
  }
  .x {
    margin-right: 2px;
    margin-left: 11px;
  }
  .x::before,
  .x::after {
    position: absolute;
    width: 9px;
    height: 3px;
    background: white;
    content: "";
    border-radius: 60px;
  }

  .x::before {
    transform: rotate(45deg);
  }
  .x::after {
    transform: rotate(-45deg);
  }

  .removeBtn::before {
    transform: rotate(45deg);
  }
  .removeBtn::after {
    transform: rotate(-45deg);
  }

  .name {
    display: list-item;
    margin-right: 20px;
    position: relative;
  }

  .price {
    margin-right: auto;
    display: flex;
    align-items: center;
    font-size: 18px;
    margin-left: 10px;
  }

  .count {
    min-width: 30px;
  }

  .itemDetails {
    margin-bottom: 35px;
  }

  span {
    font-weight: 500;
    margin-top: 2px;
    display: inline-block;
    margin-bottom: 2px;
    margin-left: 5px;
  }

  .section {
    direction: rtl;
    text-align: right;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .checkboxLabel {
    display: inline-block;
    margin-left: 5px;
  }

  .cartStyle {
    margin-right: 70px;
  }

  .orderStyle {
    margin-right: 30px;
  }

  .adminStyle {
    margin-right: 35px;
  }

  .closedOrderStyle {
    margin-right: 25px;
  }

  .boxes {
    margin-right: 10px;
  }

  .checkbox {
    display: flex;
    margin-top: 5px;
  }

  .option {
    margin-top: 5px;
  }

  @media (max-width: 576px) {
    .item,
    .price {
      font-size: 16px;
    }
  }

</style>
